import React from 'react';
import { Link } from '@bbkShared/react-router';
import { CBRetentionLogo } from '@bbkAdminComponents/cbretention-logo';
import { SignupPaths } from '@bbkAdminRouter/signup-paths';

export const TrialSignupLogo: React.FC = () => (
  <Link
    to={SignupPaths.trialSignup}
    className="tw-inline-block tw-max-w-[300px]"
  >
    <CBRetentionLogo />
  </Link>
);
